import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removerCaractersEspeciais',
  standalone: true
})
export class RemoverCaractersEspeciaisPipe implements PipeTransform {

  transform(valor: string): string {
    if (!valor) return '';

    return valor.replace(/[^a-zA-Z0-9À-ÿ ]/g, ' ');
  }

}
